import React from 'react';
import { strings } from '../../../resources/strings';
import { orderTags } from '../../../resources/orderResources';
import { Order } from '../../../models/Order';
import { Table } from '../../../common-components/Table/Table';
import { Container, Content } from './styles';

interface ITabCustomerProps {
  order?: Order | null;
}

export const TabCustomer: React.FC<ITabCustomerProps> = ({
  order
}) => {

  const customer = React.useMemo(() => {

    const shippingAddressesLength = order?.shippingAddresses?.length;
    const firstShippingAddresses = shippingAddressesLength ? order.shippingAddresses[0] : null;
    let customerName = order?.customer?.name;
    let customerEmail = order?.customer?.email;
    let customerPhone = order?.customer?.phone;
    if (order?.tags?.includes(orderTags.amaro.value) && firstShippingAddresses) {
      customerName = firstShippingAddresses.name;
      customerEmail = '';
      customerPhone = firstShippingAddresses.phone
    }

    return (
      <Table>
        <thead>
          <tr>
            <th>{strings.Name}</th>
            <th>{strings.Email}</th>
            <th>{strings.CellPhone}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{width:'40%'}}>{customerName}</td>
            <td style={{width:'40%'}}>{customerEmail}</td>
            <td style={{width:'20%'}}>{customerPhone}</td>
          </tr>
        </tbody>
      </Table>
    );
  }, [order]);

  const addresses = React.useMemo(() => {
    const shippingAddress = order?.shippingAddresses && order?.shippingAddresses.length > 0
      ? order?.shippingAddresses[0] : null;

    const billingAddress = order?.billingAddresses && order?.billingAddresses.length > 0
      ? order?.billingAddresses[0] : null;

    return (
      <Table>
        <thead>
          <tr>
            <th style={{ width: '200px' }}></th>
            <th>{strings.ShippingAddress}</th>
            <th>{strings.BillingAddress}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{strings.Principal}</td>
            <td>{shippingAddress?.address}</td>
            <td>{billingAddress?.address}</td>
          </tr>
          <tr>
            <td>{strings.Complement}</td>
            <td>{shippingAddress?.additionalAddress}</td>
            <td>{billingAddress?.additionalAddress}</td>
          </tr>
          <tr>
            <td>{strings.Zip}</td>
            <td>{shippingAddress?.zip}</td>
            <td>{billingAddress?.zip}</td>
          </tr>
          <tr>
            <td>{strings.City}</td>
            <td>{shippingAddress?.city}</td>
            <td>{billingAddress?.city}</td>
          </tr>
          <tr>
            <td>UF</td>
            <td>{shippingAddress?.provinceCode}</td>
            <td>{billingAddress?.provinceCode}</td>
          </tr>
        </tbody>
      </Table>
    );
  }, [order]);

  return (
    <Container>
      <Content>
        {customer}
      </Content>

      <Content>
        {addresses}
      </Content>
    </Container>
  );
};